export default {
    methods: {
    /**
    * Zone Click Event
    */
   GoogleMapEvents_setClickEvent(mapObject) {
        const self = this;
        if(this.zoneEvent.click) {
                return;
        }
        this.zoneEvent.click = mapObject.data.addListener('click', function _listen(event) {

            if (event.feature.getGeometry().getType() === 'Polygon') {

                // Recupero le credenziali
                var polyPath = event.feature.getGeometry().getAt(0).getArray();

                // Creo la ghost shape
                this.poly = new google.maps.Polygon({
                    paths: polyPath
                });

                // Creo il GeoJson e lo setto nella variabile di ricerca
                event.feature.toGeoJson( res => {
                    self.dataResult = res;
                    if(event.feature.getProperty('type') === 'comune') {
                        
                        mapObject.setCenter({ lat: event.feature.getProperty('center').coordinates[1], lng: event.feature.getProperty('center').coordinates[0]});

                        // Quando clicco su un comune devo deselezionare tutti gli altri comuni
                        self.deselectComuni(mapObject, event.feature);

                        // Se sto selezionando e non de-selezionando allora chiamo
                        if(! event.feature.getProperty('selected')){
                            // Mostro il loading dall'istanza principale
                            self.$root.isLoading('loading-toast');
                            // Effettuo la chiamata al server
                            window.axios.get(process.env.MIX_BASE_URL + 'zone/comune/' + event.feature.getProperty('id') + '/quartieri')
                            .then( res => {
                                // Se il comune ha delle zone geografiche
                                if(res.data.features.length > 0){
                                    // Elimino gli eventuali poligoni, cerchi o punti disegnati
                                    self.currentCircle.map(function(item) {
                                        item.setMap(null);
                                    })
                                    
                                    self.currentPolygon.map(function(item) {
                                        item.setMap(null);
                                    })
                                    // Svuota dataLayer
                                    self.emptyDataLayer();
                                    // Pusho le feature nel datalayer
                                    for( let item of res.data.features ) {
                                        mapObject.data.addGeoJson(item, mapObject);  
                                        this.zone = true;
                                    }
                                    // Rifaccio il select zona per deselezionare il comune
                                    self.selectZone(mapObject, event.feature);
                                }

                                // Stoppo il caricamento
                                self.$root.stopLoading();

                            }).catch( error => {

                                // Mostro alert
                                self.$root.alertHttp('loading-toast', 'Problemi nel caricamento dati');
                            });
                        }
                    }

                    self.selectZone(mapObject, event.feature);
                    
                });

            };
            }, true);
        },

        /**
         * Evento Hover
         */
         GoogleMapEvents_setOutsideEvent(mapObject) {
            if(this.zoneEvent.out) {
                return;
            }
            this.zoneEvent.out = mapObject.data.addListener('mouseout', (event) => {

                if (event.feature.getProperty('id')) {

                    // Uccido le eventuali infowindow
                    if (this.infowindow) {
                        this.infowindow.close();
                    }

                    if(!event.feature.getProperty('selected')) {
                        mapObject.data.overrideStyle(event.feature, {
                            fillOpacity: 0.3,
                        });
                    }
                   
                };
            });
        },

         /**
         * Evento Hover
         */
          GoogleMapEvents_setHoverEvent(mapObject) {
            if(this.zoneEvent.hover) {
                return;
            }
            this.zoneEvent.hover = mapObject.data.addListener('mouseover', function(event) {

                // Controllo di applicare l'evento solo ai poligoni
                if (event.feature.getProperty('id')) {
                    // Uccido le eventuali infowindow
                    if (this.infowindow) {
                        this.infowindow.close();
                    }

                    // Coloro l'area selezionata
                    mapObject.data.overrideStyle(event.feature, {
                        fillOpacity: 0.8,
                    });
                };
            });
        },
    }
 }